export function goBack(navigate, fallback = "/") {
  const cameFromSite = window.history.state?.idx > 0 || document.referrer.startsWith(window.location.origin);
  if (cameFromSite) { navigate(-1); return; }
  navigate(fallback, { replace: true });
}